var exports = {
  "ZO": "MessageContextPrefix.module__channelHeader___TXQ2ZD",
  "wO": "MessageContextPrefix.module__channelHeaderCompact___TXQ2ZD",
  "p": "MessageContextPrefix.module__channelIcon___TXQ2ZD",
  "uS": "MessageContextPrefix.module__channelIconAvatar___TXQ2ZD",
  "bR": "MessageContextPrefix.module__channelIconAvatarImage___TXQ2ZD",
  "D4": "MessageContextPrefix.module__channelNameButton___TXQ2ZD",
  "Kw": "MessageContextPrefix.module__channelNameText___TXQ2ZD",
  "Vf": "MessageContextPrefix.module__channelNamePrimary___TXQ2ZD",
  "S4": "MessageContextPrefix.module__channelScopeRow___TXQ2ZD",
  "AQ": "MessageContextPrefix.module__channelScopeGuildIcon___TXQ2ZD",
  "oN": "MessageContextPrefix.module__channelScopeGuildName___TXQ2ZD",
  "V$": "MessageContextPrefix.module__channelScopeChevron___TXQ2ZD",
  "fm": "MessageContextPrefix.module__channelScopeChannelInfo___TXQ2ZD",
  "Gn": "MessageContextPrefix.module__channelScopeChannelIcon___TXQ2ZD",
  "wF": "MessageContextPrefix.module__channelScopeChannelName___TXQ2ZD",
  "bo": "MessageContextPrefix.module__focusRingTight___TXQ2ZD",
};

module.exports = exports;
